import React from 'react'
import { SecurityAccess } from './.'
import { connect } from 'react-redux'
import { fetchParticipant } from 'Participant/ducks'
import { fetchSonarStatus } from '../UraPassword/UnlockUraPassword/actions'
import { fetchHasUraPass } from '../UraPassword/CreateUraPassword/ducks'

const mapStateToProps = ({ securityAccess, participant, oidc }) => ({
  email: participant.email,
  userInfo: oidc.user.profile,
  document: participant.cpf,
  ...securityAccess
})

const mapDispatchToProps = dispatch => ({
  fetchParticipant: () => dispatch(fetchParticipant()),
  fetchSonarStatus: () => dispatch(fetchSonarStatus()),
  fetchHasUraPass: (cpf) => dispatch(fetchHasUraPass(cpf))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(props => <SecurityAccess {...props} />)



// WEBPACK FOOTER //
// ./src/Participant/SecurityAccess/SecurityAccessPage.js